import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import de from './locales/de/translation.json';

function detectLanguage() {
  const stored = localStorage.getItem('language');
  if (stored === 'en' || stored === 'de') return stored;
  const lang = navigator.language || navigator.languages?.[0] || 'en';
  return lang.startsWith('de') ? 'de' : 'en';
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  lng: detectLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
